import React from "react";
import "./Common_heading.css";

function Common_heading({title, subtitle}) {
  return (
    <>
      <section className="Common_heading">
        <div className="header_holder">
          <h5 className="title">{title}</h5>
          <p className="subtitle">{subtitle}</p>
        </div>
      </section>
    </>
  );
}

export default Common_heading;
